import React from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import './filterBadge.scss';

const FilterBadge = ({ label, value, onClear }) => {
    return (
        <div className="filter-badge">
            <span className="badge-label">{label}:</span>
            <span className="badge-value">{value}</span>
            {onClear && (
                <button className="clear-btn" onClick={onClear}>
                    <ClearIcon fontSize="small" />
                </button>
            )}
        </div>
    );
};

export default FilterBadge;